import React from 'react';
import { ColorPickerInput } from '../../../../../ui/ColorPickerInput';
import { useMapEditor } from '../../../../contexts/MapEditorContext';
import { PanelSectionWrapper } from '../PanelSectionWrapper';
import { ShapeSectionOptions } from '../ShapePanel';

export const CommonColorPanelControls: React.FC<ShapeSectionOptions> = ({
  shapes
}) => {
  const { updateShape, shapes: editorShapes } = useMapEditor();
  const shape = shapes[0];

  const handleChangeColor = (value: string) => {
    shapes.forEach((shape) => {
      updateShape(shape.id, { color: value });
    });
  };

  const paletteColors: string[] = React.useMemo(() => {
    return editorShapes.reduce((colors, shape) => {
      if (shape.color && !colors.includes(shape.color)) {
        colors.push(shape.color);
      }

      return colors;
    }, [] as string[]);
  }, [editorShapes]);

  return (
    <PanelSectionWrapper title={'Color'}>
      <div className={'flex gap-2'}>
        <div className="flex flex-col gap-1">
          <div className="font-medium text-sm">Color</div>
          <ColorPickerInput
            value={shape.color || ''}
            onChange={handleChangeColor}
            paletteColors={paletteColors}
          />
        </div>
        <div />
      </div>
    </PanelSectionWrapper>
  );
};
